import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';

@Component({
  selector: 'app-cine',
  templateUrl: './cine.component.html',
  styleUrls: ['./cine.component.css']
})
export class CineComponent implements OnInit {
  cartelera: any = false;

  constructor(private totemService: TotemService) { }

  ngOnInit() {
    this.obtenerCartelera();
  }

  async obtenerCartelera() {
    try {
      await this.totemService.geteventos(20).toPromise().then((res: any) => {
        this.cartelera = res.filter(evento => evento.tipo_evento === 'Cartelera' && !!evento.publicado)
      });
      console.log('[PELICULAS]', this.cartelera);
    } catch (err) {
      console.log(err);
    }
  }

}
